import { CorporateDocsTable } from '../../shared/components/corporate-docs-table/corporate-docs-table';
import { StartOrderBtn } from '../../shared/components/start-order-btn/start-order-btn';
import { HaveQuestion } from '../../shared/components/have-question/have-question';
import { FdaTable } from '../../shared/components/fda-table/fda-table';

export const dynamicComponents: Record<string, any> = {
  '$corporateTable': CorporateDocsTable,
  '$fdaTable': FdaTable,
  '$actionBtn': StartOrderBtn,
  '$submitAQuestion': HaveQuestion,
};